export const getTaskModel = ({
  taskName = "",
  description = "",
  category = null,
  user_data = [],
  comments = [],
}) => {
  return {
    name: taskName,
    description: description,
    category: category,
    user_data: user_data,
    comments: comments,
    completed: false,
  };
};

export const formatDate = (dateStr) =>
  new Date(dateStr).toLocaleString("it-IT", {
    day: "numeric",
    month: "long",
    year: "numeric",
    hour: "numeric",
    minute: "numeric",
  });

export const formatDateNumeric = (dateStr) =>
  new Date(dateStr).toLocaleString("it-IT", {
    day: "numeric",
    month: "numeric",
    year: "numeric",
    hour: "numeric",
    minute: "numeric",
  });

export const toDjangoDate = (date) => {
  return (
    date.getFullYear() +
    "-" +
    (date.getMonth() + 1).toString().padStart(2, "0") +
    "-" +
    date.getDate().toString().padStart(2, "0")
  );
};
